module.exports = __webpack_public_path__ + "static/media/chess-sketch.26a89680.jpg";